import {I18n} from 'aws-amplify/utils';

import {FlexiAddButton,} from '@flexinet/ui-components';

import {useNavigate} from 'react-router-dom';

export const AddRecordButton = ({
                                    buttonText = 'Add Domain Name',
                                    onClick,
                                }: {
    buttonText?: string,
    onClick?: () => void
}) => {
    const navigate = useNavigate();

    if (typeof onClick === 'undefined') {
        onClick = () => {
            navigate('/domain-names/add');
        };
    }

    return (
        <FlexiAddButton
            onClick={onClick}
        >
            {I18n.get(buttonText)}
        </FlexiAddButton>
    );
};
